import type { GTMEvent } from '@types'

export default function sendGTMEvent(event: GTMEvent): void {
  if (typeof window !== 'undefined' && typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push({ event })
  }
}
